module.exports = __webpack_public_path__ + "img/16.6ac4ad01.png";